'use client';
import { NAV_CONTENT_ID } from '@/constants';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export const ScrollToSection = () => {
  const searchParams = useSearchParams();

  useEffect(() => {
    const hash = window.location.hash;

    if (hash) {
      const id = hash.substring(1);
      // There might be multiple elements with same id, one for mobile and one for desktop
      const element = document.querySelectorAll<HTMLElement>(`#${id}`);

      if (element.length === 0) {
        return;
      }

      element.forEach((el) => {
        if (getComputedStyle(el).display === 'none') {
          return;
        }
        const navElement = document.getElementById(NAV_CONTENT_ID);
        const navHeight = navElement ? navElement.clientHeight : 0;

        window.scrollTo({
          top: el.getBoundingClientRect().top + scrollY - navHeight,
          behavior: 'smooth',
        });

        let tabIndexAdded = false;

        if (!el.hasAttribute('tabindex')) {
          el.setAttribute('tabindex', '0');
          tabIndexAdded = true;
        }

        if (typeof el.focus === 'function' && el.tabIndex >= 0) {
          el.focus({ preventScroll: true });
          if (tabIndexAdded) {
            el.removeAttribute('tabindex');
          }
        }

        setTimeout(() => {
          window.history.replaceState(
            null,
            '',
            window.location.pathname + window.location.search,
          );
        }, 0);
      });
    }
    // Use the searchParams to trigger the effect when the URL changes
  }, [searchParams]);

  return null;
};
